import { createAction, props } from '@ngrx/store';

export const InitUserFirstPassword = createAction(
  '[InitUserFirstPassword] Action',
  props<{ model: {} }>()
);

export const FinishUserFirstPassword = createAction(
  '[FinishUserFirstPassword] Action',
  props<{ model: {} }>()
);

export const ValidateUserFirstPasswordToken = createAction(
  '[ValidateUserFirstPasswordToken] Action',
  props<{ isTokenValid: boolean }>()
);

export const ValidateResetPasswordToken = createAction(
  '[ValidateResetPasswordToken] Action',
  props<{ isTokenValid: boolean }>()
);
